import { Util } from "@grandvisionhq/forms";
import { useAdyen } from "@grandvisionhq/payments";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
const isEmailValid = (email) => email && Util.validations.isEmailAddress(email);
const isPostalCodeValid = (country, postalCode) => country && postalCode && Util.validations.isValidPostalCodeForCountry(country, postalCode);
const useValidatePaymentData = () => {
  const { getLabel } = useIntl();
  const { featureConfigs, allowAlternativeShippingState } = useFeatureToggles();
  const { config } = useAdyen();
  const addressValidation = config?.googlepay?.addressValidation;
  return (intermediatePaymentData, isShippingRequired) => {
    const { shippingAddress, paymentMethodData, email } = intermediatePaymentData;
    const billingAddress = paymentMethodData.info?.billingAddress;
    if (!isEmailValid(email)) {
      return {
        isPaymentDataValid: false,
        error: {
          reason: "SHIPPING_ADDRESS_INVALID",
          message: getLabel("checkout.contact.email.errorMessage"),
          intent: "SHIPPING_ADDRESS"
        }
      };
    }
    if (allowAlternativeShippingState && featureConfigs.alternativeShippingRegex) {
      const postalCodeIsInvalid = shippingAddress?.postalCode && featureConfigs.alternativeShippingRegex.test(shippingAddress.postalCode);
      if (postalCodeIsInvalid) {
        return {
          isPaymentDataValid: false,
          error: {
            reason: "SHIPPING_ADDRESS_INVALID",
            message: getLabel("checkout.address.postalCode.unavailable.errorMessage"),
            intent: "SHIPPING_ADDRESS"
          }
        };
      }
    }
    if (!isPostalCodeValid(billingAddress?.countryCode, billingAddress?.postalCode)) {
      return {
        isPaymentDataValid: false,
        error: {
          reason: "SHIPPING_ADDRESS_INVALID",
          message: getLabel("checkout.address.postalCode.errorMessage"),
          intent: "SHIPPING_ADDRESS"
        }
      };
    }
    if (shippingAddress) {
      if (!isPostalCodeValid(shippingAddress?.countryCode, shippingAddress?.postalCode)) {
        return {
          isPaymentDataValid: false,
          error: {
            reason: "SHIPPING_ADDRESS_INVALID",
            message: getLabel("checkout.address.postalCode.errorMessage"),
            intent: "SHIPPING_ADDRESS"
          }
        };
      }
      if (addressValidation?.streetName && !addressValidation?.streetName(shippingAddress?.address1 || "")) {
        return {
          isPaymentDataValid: false,
          error: {
            reason: "SHIPPING_ADDRESS_INVALID",
            message: getLabel("checkout.address.streetName.errorMessage"),
            intent: "SHIPPING_ADDRESS"
          }
        };
      }
      if (addressValidation?.fullName && !addressValidation?.fullName(shippingAddress?.name || "")) {
        return {
          isPaymentDataValid: false,
          error: {
            reason: "SHIPPING_ADDRESS_INVALID",
            message: getLabel("checkout.address.fullName.errorMessage"),
            intent: "SHIPPING_ADDRESS"
          }
        };
      }
      if (shippingAddress?.address2 && addressValidation?.additionalStreetInfo && !addressValidation?.additionalStreetInfo(shippingAddress?.address2 || "")) {
        return {
          isPaymentDataValid: false,
          error: {
            reason: "SHIPPING_ADDRESS_INVALID",
            message: getLabel("checkout.address.additionalStreetInfo.errorMessage"),
            intent: "SHIPPING_ADDRESS"
          }
        };
      }
      if (shippingAddress?.address3 && addressValidation?.additionalStreetInfo && !addressValidation?.additionalStreetInfo(shippingAddress?.address3 || "")) {
        return {
          isPaymentDataValid: false,
          error: {
            reason: "SHIPPING_ADDRESS_INVALID",
            message: getLabel("checkout.address.additionalStreetInfo.errorMessage"),
            intent: "SHIPPING_ADDRESS"
          }
        };
      }
    }
    if (isShippingRequired && !shippingAddress) {
      return {
        isPaymentDataValid: false,
        error: {
          reason: "SHIPPING_ADDRESS_INVALID",
          message: getLabel("checkout.address.shipping.required.errorMessage"),
          intent: "SHIPPING_ADDRESS"
        }
      };
    }
    if (!billingAddress?.locality) {
      return {
        isPaymentDataValid: false,
        error: {
          reason: "SHIPPING_ADDRESS_INVALID",
          message: getLabel("checkout.address.city.errorMessage"),
          intent: "SHIPPING_ADDRESS"
        }
      };
    }
    if (!billingAddress?.phoneNumber) {
      return {
        isPaymentDataValid: false,
        error: {
          reason: "SHIPPING_ADDRESS_INVALID",
          message: getLabel("checkout.contact.phoneNumber.errorMessage"),
          intent: "SHIPPING_ADDRESS"
        }
      };
    }
    return { isPaymentDataValid: true };
  };
};
export {
  useValidatePaymentData
};
//# sourceMappingURL=use-validate-payment-data.js.map
